import React, { useCallback } from 'react';
import { Edit } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';
import { actions } from '../ClientView.redux';

const ClientContactMethodsEditButton = ({ id }) => {
    const dispatch = useDispatch();

    const openModal = useCallback(() => {
        dispatch(actions.openContactMethodEditModal(id));
    }, [dispatch, id]);

    return (
        <IconButton
            size="small"
            onClick={(event) => {
                event.stopPropagation();
                openModal();
            }}
        >
            <Edit />
        </IconButton>
    );
};

export default ClientContactMethodsEditButton;
